"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentAccount_1 = __importDefault(require("./PaymentAccount"));
var EInvoiceProfile_1 = __importDefault(require("./EInvoiceProfile"));
var Branch = /** @class */ (function () {
    function Branch(json) {
        this.id = json.id;
        this.name = json.name;
        this.address = json.address;
        this.receiptLogo = json.receiptLogo;
        this.registrationNumber = json.registrationNumber;
        this.invoiceFooterNotes = json.invoiceFooterNotes;
        this.phoneNumber = json.phoneNumber;
        this.whatsAppNumber = json.whatsAppNumber;
        if (json.paymentAccounts != null) {
            this.paymentAccounts = json.paymentAccounts.map(function (paj) { return new PaymentAccount_1.default(paj); });
        }
        else {
            this.paymentAccounts = [];
        }
        this.eInvoiceProfile = json.eInvoiceProfile ? new EInvoiceProfile_1.default(json.eInvoiceProfile) : null;
        this.collectionTicketMessage = json.collectionTicketMessage;
    }
    Object.defineProperty(Branch.prototype, Symbol.toStringTag, {
        get: function () {
            return 'Branch';
        },
        enumerable: false,
        configurable: true
    });
    return Branch;
}());
exports.default = Branch;
